function CameraIcon({ width = 55, height = 55, color = "#292d32" }) {
  return (
    <svg
      width={`${width}`}
      height={`${height}`}
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.91185 43.5648L5.86602 43.6107C5.24727 42.2586 4.85768 40.7232 4.69727 39.0273C4.85768 40.7003 5.2931 42.2128 5.91185 43.5648Z"
        fill={`${color}`}
      />
      <path
        d="M20.6241 23.7872C23.6363 23.7872 26.0783 21.3453 26.0783 18.3331C26.0783 15.3208 23.6363 12.8789 20.6241 12.8789C17.6118 12.8789 15.1699 15.3208 15.1699 18.3331C15.1699 21.3453 17.6118 23.7872 20.6241 23.7872Z"
        fill={`${color}`}
      />
      <path
        d="M37.1027 4.58398H17.8986C9.5569 4.58398 4.58398 9.5569 4.58398 17.8986V37.1027C4.58398 39.6007 5.0194 41.7777 5.86732 43.6111C7.83815 47.9652 12.0548 50.4173 17.8986 50.4173H37.1027C45.4444 50.4173 50.4173 45.4444 50.4173 37.1027V31.8548V17.8986C50.4173 9.5569 45.4444 4.58398 37.1027 4.58398ZM46.6819 28.6465C44.8944 27.1111 42.0069 27.1111 40.2194 28.6465L30.6861 36.8277C28.8986 38.3632 26.0111 38.3632 24.2236 36.8277L23.4444 36.1861C21.8173 34.7652 19.2277 34.6277 17.3944 35.8652L8.82357 41.6173C8.3194 40.334 8.02148 38.8444 8.02148 37.1027V17.8986C8.02148 11.4361 11.4361 8.02148 17.8986 8.02148H37.1027C43.5652 8.02148 46.9798 11.4361 46.9798 17.8986V28.8986L46.6819 28.6465Z"
        fill={`${color}`}
      />
    </svg>
  );
}

export default CameraIcon;
